import { Address } from '@adornis/address/db/address.js';
import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { iban } from '@adornis/validation/functions/iban.js';

@Entity()
export class LecturerData extends MongoEntity {
  static override _class = 'LecturerData';
  static override _collectionName = 'lecturer-data';

  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  override _id!: string;

  @Field(type => String)
  lecturerID: Maybe<string>;

  @Field(type => Address, { default: v => v ?? new Address({}) })
  billingAddress: Maybe<Address>;

  @validate(iban({ allowEmpty: true }))
  @Field(type => String)
  iban: Maybe<string>;

  @Field(type => String)
  salutation: Maybe<string>;

  @Field(type => String)
  phone: Maybe<string>;

  @Field(type => String)
  title: Maybe<string>;
}
